'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasds';
var iconName = 'diamond-half-stroke';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'e5b8';
var svgPathData = ['M256 0l0 90.5L421.5 256 256 421.5l0 90.5 45.3-45.3L466.7 301.3 512 256l-45.3-45.3L301.3 45.3 256 0z', 'M256 0L0 256 256 512 256 0z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faDiamondHalfStroke = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;